import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DOMUtils from '@spothero/utils/dom';
import moment from 'moment-timezone';
import unescape from 'lodash/unescape';
import WithConfig from 'config/WithConfig';
import Button from '@spothero/ui/button';
import Icon from 'common/icon/Icon';
import SearchAirportMap from 'search/map/SearchAirportMap';
import SearchAirportFilters from './SearchAirportFiltersResponsive';
import SearchAirportResult from './SearchAirportCardResponsive';
import SHLoader from 'common/loader/SHLoader';
import classNames from 'classnames';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import {push} from 'router/router-actions';
import {updateSelected} from 'spot/spot-actions';
import {getSpots} from 'spots/spots-selectors';

const DATETIME_FORMAT = 'MMMM D [at] H:mm A';

class SearchAirportResultsResponsive extends Component {
    static propTypes = {
        destinationTitle: PropTypes.string,
        iataCode: PropTypes.string,
        isLoading: PropTypes.bool,
        pushTo: PropTypes.func.isRequired,
        spots: PropTypes.arrayOf(PropTypes.object).isRequired,
        spotCount: PropTypes.number,
        updateSelectedSpot: PropTypes.func.isRequired,
        starts: PropTypes.string,
        ends: PropTypes.string,
        siteUrl: PropTypes.string.isRequired,
        citySlug: PropTypes.string.isRequired,
        destinationRelativeUrl: PropTypes.string.isRequired,
        urlParams: PropTypes.string.isRequired,
    }

    state = {
        isMapView: false,
    };

    componentDidMount() {
        this._searchPageContainer = DOMUtils.el('body');
    }

    componentWillUnmount() {
        DOMUtils.removeClass(this._searchPageContainer, 'search-airport-page-inactive');
    }

    _onToggleViewType = () => {
        DOMUtils.toggleClass(this._searchPageContainer, 'search-airport-page-inactive');

        this.setState(state => {
            return {
                isMapView: !state.isMapView
            };
        });
    }

    render() {
        const {
            destinationTitle,
            iataCode,
            isLoading,
            pushTo,
            updateSelectedSpot,
            starts,
            ends,
            spots,
            spotCount,
            siteUrl,
            citySlug,
            destinationRelativeUrl,
            urlParams
        } = this.props;
        const {
            isMapView,
        } = this.state;
        const listViewClasses = classNames(
            'SearchAirportResultsResponsive-pane',
            {'SearchAirportResultsResponsive-pane-inactive': isMapView}
        );
        const mapViewClasses = classNames(
            'SearchAirportResultsResponsive-pane',
            {'SearchAirportResultsResponsive-pane-inactive': !isMapView || isLoading},
            'SearchAirportResultsResponsive-faux-modal-sticky-panel'
        );

        return (
            <div className="SearchAirportResultsResponsive">
                <section className={listViewClasses}>
                    {Boolean(spotCount) && (
                        <SearchAirportFilters
                            spotCount={spotCount}
                            onToggleViewType={this._onToggleViewType}
                        />
                    )}
                    <ul
                        className="SearchAirportResultsResponsive-spots"
                        itemScope
                        itemType="http://schema.org/ItemList"
                    >
                        <link
                            itemProp="url"
                            href={`${siteUrl}/${citySlug}/${destinationRelativeUrl}${urlParams}`}
                        />
                        {Boolean(spotCount) &&
                            <meta
                                itemProp="numberOfItems"
                                content={spotCount}
                            />
                        }
                        {(isLoading)
                            ? <SHLoader />
                            : (spotCount)
                                ? spots.map((spot, index) => {
                                    return (
                                        <li
                                            key={spot.spotId}
                                            itemProp="itemListElement"
                                            itemScope
                                            itemType="http://schema.org/ListItem"
                                        >
                                            <meta
                                                itemProp="position"
                                                content={index + 1}
                                            />
                                            <SearchAirportResult
                                                spot={spot}
                                                starts={starts}
                                                ends={ends}
                                                updateSelectedSpot={updateSelectedSpot}
                                                pushTo={pushTo}
                                            />
                                        </li>
                                    );
                                }) : (
                                    <li className="SearchAirportResultsResponsive-no-spots">
                                        No spots are available at {unescape(destinationTitle)} for {moment(starts).format(DATETIME_FORMAT)} to {moment(ends).format(DATETIME_FORMAT)}.
                                        <br />
                                        Please adjust your search to see if other spots can be booked.
                                    </li>
                                )
                        }
                    </ul>
                </section>
                <section className={mapViewClasses}>
                    <header className="SearchAirportResultsResponsive-map-header">
                        <h1>{`Parking${(iataCode) ? ` Near ${iataCode}` : ''}`}</h1>
                        <Button onClick={this._onToggleViewType}>
                            <Icon name="times" />
                        </Button>
                    </header>
                    <div className="SearchAirportResultsResponsive-map-container">
                        <SearchAirportMap spots={spots} />
                    </div>
                </section>
            </div>
        );
    }
}

const makeMapStateToProps = () => {
    const mapStateToProps = state => {
        const {
            city: {
                data: {
                    slug: citySlug
                }
            },
            destination: {
                data: {
                    airport: {
                        iata_code: iataCode,
                    },
                    title: destinationTitle,
                    relative_url: destinationRelativeUrl
                }
            },
            spots: {
                isPending: isLoadingSpots
            },
            searchRequest: {
                isRouteLoading,
                starts,
                ends
            },
        } = state;
        const spots = getSpots(state);

        return {
            destinationTitle,
            iataCode,
            starts,
            ends,
            spots,
            citySlug,
            destinationRelativeUrl,
            urlParams: `?starts=${encodeURIComponent(starts)}&ends=${encodeURIComponent(ends)}`,
            spotCount: (spots) ? spots.length : 0,
            isLoading: isRouteLoading || isLoadingSpots,
        };
    };

    return mapStateToProps;
};
const mapDispatchToProps = {
    updateSelectedSpot: updateSelected,
    pushTo: push,
};
const enhance = compose(
    WithConfig,
    connect(makeMapStateToProps, mapDispatchToProps)
);

export default enhance(SearchAirportResultsResponsive);

